module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "epigraph"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-top": "20%"
    }
  }, [_c('i', [_vm._v("All the rivers run into the sea; yet the sea is not full; unto the place from whence the rivers come, thither they return again. All things are\n        full of labour; man cannot utter it: the eye is not satisfied with seeing, nor the ear filled with hearing. The thing that hath been, it is that which shall be; and that which is done is that\n        which shall be done: and there is no new thing under the sun.")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("Ecclesiastes 1:7–9")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fae5e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/006_epigraph.vue
// module id = 75
// module chunks = 0